import { ChatApiService } from './api/ChatService';

export const contactsHistory = async (payload, userToken) => {
    try {
        const queryParams = new URLSearchParams()

        payload.page && queryParams.append('page', payload.page)
        payload.perPage && queryParams.append('per_page', payload.perPage)
        payload.search && queryParams.append('search', payload.search)
        payload.userId && queryParams.append('user_id', payload.userId)

        const queryString = queryParams.toString()
        const url = queryString ? `/contacts/history?${queryString}` : '/contacts/history'

        const response = await ChatApiService.get(url, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar histórico de contatos', error);

        throw error;
    }
}

export const validateContact = async (payload, userToken) => {
    try {
        const response = await ChatApiService.post('/contacts/validate', payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao validar contatos', error);

        throw error;
    }
}

export const sendEmailsToContacts = async (payload, userToken) => {
    try {
        const response = await ChatApiService.post('/contacts/send-emails', payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao enviar emails para contatos', error);

        throw error;
    }
}

export const redispatchContacts = async (payload, userToken) => {
    try {
        const response = await ChatApiService.post(`/contacts/re-dispatch/${payload.dispatchId}`, payload, {
            headers: {
                'Authorization': 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao redistribuir contatos', error);

        throw error;
    }
}
